import { useState } from 'react'
import './App.css'
import CircularProgress from '@mui/material/CircularProgress'
import {  CssBaseline, Backdrop, Typography, Box } from '@mui/material'
import { ThemeProvider } from './context/themeContext'
import Layout from './dashboardAdmin/layout/layout'
import { Routes, Route } from 'react-router'
import LoginView from './dashboardAdmin/user/views/loginView'
import { CanGuest } from './shared/components/CanGuest' 
import { useAuth } from './shared/context/authContext'
import checkIso from './assets/checkIso.png'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import 'dayjs/locale/es'
import { useUtiles } from './shared/context/utilesContext'

function App() {
  const {loadingLoginEmail, loadingRedirectCallback, loadingLogout} = useAuth()
  const { loadingApi } = useUtiles()



  return (
    <>
    <ThemeProvider>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <CssBaseline />

        <Routes>
          <Route path="/login" element={<CanGuest><LoginView /></CanGuest>} /> 
          <Route path="/*" element={<Layout />} />
        </Routes>
            
        <Backdrop
          sx={{
            color: '#fff',
            zIndex: (theme) => theme.zIndex.drawer + 1,
            flexDirection: 'column',
            gap: 2
          }}
          open={loadingLoginEmail || loadingRedirectCallback}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <img src={checkIso} alt="checkIso" style={{ width: '32px', height: '32px' }} />
            <Typography variant="body1" className='logoFont' >
              MantTrack
            </Typography>
  
          </Box>
          <Typography variant="body1" sx={{ fontStyle: 'italic' }}>
            Preparando su experiencia digital, un momento por favor...
          </Typography>
        </Backdrop>

        <Backdrop
          sx={{
            color: '#fff',
            zIndex: (theme) => theme.zIndex.drawer + 1,
            flexDirection: 'column',
            gap: 3,
            backdropFilter: 'blur(8px)',
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            transition: 'all 0.3s ease-in-out'
          }}
          open={loadingLogout}
        >
          <Box 
            sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: 2,
              padding: '16px 24px',
              borderRadius: '12px',
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)'
            }}
          >
            <img 
              src={checkIso} 
              alt="checkIso" 
              style={{ 
                width: '40px', 
                height: '40px',
                filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2))'
              }} 
            />
            <Typography 
              variant="h5" 
              className='logoFont'
              sx={{
                fontWeight: 600,
                letterSpacing: '0.5px'
              }}
            >
              MantTrack
            </Typography>
            
          </Box>
          <Typography 
            variant="h6" 
            sx={{ 
              fontStyle: 'italic',
              opacity: 0.9,
              textAlign: 'center',
              maxWidth: '400px',
              lineHeight: 1.5
            }}
          >
            Guardando su progreso, volveremos a vernos pronto...
          </Typography>
        </Backdrop>

        <Backdrop
          sx={{
            color: '#fff',
            zIndex: (theme) => theme.zIndex.drawer + 1,
            flexDirection: 'column',
            gap: 2,
            backdropFilter: 'blur(4px)',
            backgroundColor: 'rgba(0, 0, 0, 0.6)'
          }}
          open={loadingApi}
        >
          <Box 
            sx={{ 
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 3,
              padding: '24px',
              borderRadius: '16px',
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)'
            }}
          >
            <CircularProgress 
              size={48}
              thickness={4}
              sx={{
                color: 'primary.main',
                filter: 'drop-shadow(0 0 8px rgba(255, 255, 255, 0.3))'
              }}
            />
            <Box sx={{ textAlign: 'center' }}>
              <Typography 
                variant="h6" 
                sx={{ 
                  fontWeight: 500,
                  marginBottom: 1,
                  textShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
                }}
              >
                Obteniendo datos
              </Typography>
              <Typography 
                variant="body1" 
                sx={{ 
                  opacity: 0.9,
                  fontStyle: 'italic',
                  maxWidth: '300px',
                  lineHeight: 1.5
                }}
              >
                Estamos procesando su solicitud, esto tomará solo un momento...
              </Typography>
            </Box>
          </Box>
        </Backdrop>

      </LocalizationProvider>
    </ThemeProvider>
    </>
  )
}

export default App
